import React from 'react';
const n = value => Number(value).toLocaleString('ro-RO', { maximumFractionDigits: 6 });
export function physicalWeight(pieces, length, width, kind, factor) {
  const size = Number(length) * (kind === 'sheet' ? Number(width) : 1);
  const kg = size * Number(factor);
  return size > 0 && Number(factor) > 0 && Number.isFinite(kg) && Number(pieces) >= 0
    ? { perPiece: kg, total: kg * Number(pieces), physical: size * Number(pieces) } : null;
}
export default function PhysicalWeight({ pieces, length, width, kind, factor }) {
  const weight = physicalWeight(pieces, length, width, kind, factor);
  return weight ? <div><small>{n(weight.perPiece)} kg/buc. · {n(weight.total)} kg total</small></div> : null;
}
